import { useState, useEffect, useRef, useContext } from 'react';
import HeaderBanner from '../sub-components/HeaderBanner.tsx';
import Footer from "../sub-components/Footer.tsx";
import OrderedDataTable from '../sub-components/OrderedDataTableCopy.jsx';
import { HttpContext } from '../../api-services/HttpService';
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from 'redux';
import { actionCreators } from "../../redux/index";
import {styled, Typography } from '@mui/material';
import PageTabs from '../sub-components/PageTabsCopy.jsx';
import ConsortiumViewRow from '../sub-components/ConsortiumViewClientInfoRow';
import PageContext from '../sub-components/PageContext';
import ViewSubCompaniesModal from '../sub-components/ViewCompaniesModal';
import EditConsortiumModal from '../sub-components/EditConsortiumModal';
import AddConsortiumMasterCompany from '../sub-components/AddConsortiumMasterCompany';
import SnackbarAlert from '../sub-components/SnackbarAlert'; 
import RemoveConsortiumMasterCompany from '../sub-components/RemoveConsortiumMasterCompany';
import StandardRowFormatted from '../sub-components/StandardRowFormatted'; 
import statusFilter from '../functions/statusFilter';
import applyFilters from '../functions/applyFilters';
import PageDropdown from '../sub-components/PageDropdownWithIdObjCopy.jsx';
import standardFilter from '../functions/standardFilter'; 
import AddConsortiumRebateSetup from '../sub-components/AddConsortiumRebateSetup';
import EditConsortiumRebateSetup from '../sub-components/EditConsortiumRebateSetup';
import AddGroupRebateSetup from '../sub-components/AddGroupRebateSetup';
import EditGroupRebateSetup from '../sub-components/EditGroupRebateSetup';
import AddConsortiumGroupModal from '../sub-components/AddConsortiumGroupModal'; 
import EditConsortiumGroupModal from '../sub-components/EditConsortiumGroupModal'; 
import RebateComponentDisplay from '../sub-components/RebateComponentDisplayCopy.jsx';
import RebateComponentsEditModal from '../sub-components/RebateComponentsEditModal'; 
import PageBreadcrumbs from '../sub-components/PageBreadcrumbs.jsx'; 
import InfoLabel from '../sub-components/InfoLabel.jsx';
import ButtonComponent from '../sub-components/ButtonComponent.jsx';
import PageDropdownBasic from '../sub-components/PageDropdownCopy.jsx';

//Styled Topography for table name
const TableName = styled(Typography)(({ theme }) => ({
    // background: "#E6F6FA",
    // color: "#3D3D3D",
    background: process.env.REACT_APP_LABEL_COLOR,
    color: `${process.env.REACT_APP_LABEL_TEXT_COLOR} !important`,
    justifyContent: "center",
    fontSize: "14px",
    minHeight: "40px",
    lineHeight: "24px",
    display: "flex",
    alignItems: "center",
    fontFamily:"Roboto medium, Helvetica, Arial, sans-serif"
}));

const ConsortiumManagementPage = () => {
    // get HTTP context from parent
    const {
        GET, 
    } = useContext(HttpContext); 
    // get global redux state 
    const consortiumId = useSelector((state) => state.consortiumId);
    const backPath = useSelector((state) => state.backPath); 
    const dispatch = useDispatch();
    const { setConsortiumId, setBackPath } = bindActionCreators(actionCreators, dispatch);
    // initialize state 
    const [portfolio, setPortfolio] = useState(''); 
    const [portfolioObj, setPortfolioObj] = useState({}); 
    const [portfolioList, setPortfolioList] = useState([]); 
    const [consortiumPayoutType, setConsortiumPayoutType] = useState('');
    const [consortiumPayoutTypeObj, setConsortiumPayoutTypeObj] = useState({}); 
    const [consortiumPayoutTypeList, setConsortiumPayoutTypeList] = useState([]);
    const [editButtonBool, setEditButtonBool] = useState(false); 
    const [showSpinner, setShowSpinner] = useState(false); 
    const [enableResetRebateTab, setEnableResetRebateTab] = useState(false);
    const [enableResetGroupSetupTab, setEnableResetGroupSetupTab] = useState(false);
    const [isMenuLoaded, setIsMenuLoaded] = useState(false);
    const defaultCheckboxDropdownState = 'Active';
    const [setupTypeList] = useState(['All','Active','Inactive']);
    
    // initialize page table 
    const [tabValue, setTabValue] = useState(0); 
    const pageTabs = [
        {tag: 'Members', key: 0, active: true }, 
        {tag: 'Rebate Setups', key: 1, active: process.env.REACT_APP_CONSORTIUM_MANAGEMENT == '1' }, 
        {tag: 'Group', key: 2, active: process.env.REACT_APP_CONSORTIUM_MANAGEMENT == '1' }, 
        {tag: 'Group Setups', key: 3, active: process.env.REACT_APP_CONSORTIUM_MANAGEMENT == '1' },
    ]; 
    const [tabList, setTabList] = useState(pageTabs); 
    // initailize memeber tab state
    const [consortiumDataList, setConsortiumDataList] = useState([]); 
    const [consortiumTableHeader, setConsortiumTableHeader] = useState([]); 
    // initialize rebate setups tab state
    const [rebateSetupDataList, setRebateSetupDataList] = useState([]); 
    const [showRebateSetupDataList, setShowRebateSetupDataList] = useState([]); 
    const [rebateSetupTableHeader, setRebateSetupTableHeader] = useState([]); 
    const [rebateInputTypeId, setRebateInputTypeId] = useState(0); 
    const [showInactiveRebateSetups, setShowInactiveRebateSetups] = useState(defaultCheckboxDropdownState); 
    // initialize consortium group tab state
    const [groupDataList, setGroupDataList] = useState([]); 
    const [groupTableHeader, setGroupTableHeader] = useState([]); 
    const [groupDataListLength, setGroupDataListLength] = useState(0); 
    const [groupRebateSetupDataList, setGroupRebateSetupDataList] = useState([]); 
    const [showGroupRebateSetupDataList, setShowGroupRebateSetupDataList] = useState([]); 
    const [groupRebateSetupTableHeader, setGroupRebateSetupTableHeader] = useState([]); 
    const [showInactiveGroupSetups, setShowInactiveGroupSetups] = useState(defaultCheckboxDropdownState); 
    // initialize state for view sub company modal 
    const [viewModal, setViewModal] = useState(false);
    const [viewCompany, setViewCompany] = useState({}); 
    // initialize state for modals 
    const [editConsortiumModal, setEditConsortiumModal] = useState(false); 
    const [addConsortiumMasterCompanyModal, setAddConsortiumMasterCompanyModal] = useState(false); 
    const [addConsortiumRebateSetupModal, setAddConsortiumRebateSetupModal] = useState(false); 
    const [editConsortiumRebateSetupModal, setEditConsortiumRebateSetupModal] = useState(false); 
    const [editConsortiumRebateSetupRow, setEditConsortiumRebateSetupRow] = useState({}); 
    const [addGroupRebateSetupModal, setAddGroupRebateSetupModal] = useState(false);
    const [editGroupRebateSetupModal, setEditGroupRebateSetupModal] = useState(false); 
    const [editGroupRebateSetupRow, setEditGroupRebateSetupRow] = useState({});
    const [addConsortiumGroupModal, setAddConsortiumGroupModal] = useState(false); 
    const [editConsortiumGroupModal, setEditConsortiumGroupModal] = useState(false); 
    const [editConsortiumGroupRow, setEditConsortiumGroupRow] = useState({}); 
    // intialize edit modal for remove master company from consortium
    const [editModal, setEditModal] = useState(false); 
    const [editCompany, setEditCompany] = useState({}); 
    const [masterCompanyList, setMasterCompanyList] = useState([]); 
    // initialize snackbar state
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarColor, setSnackbarColor] = useState('info');
    // initialize state for filter 
    const [triggerFilter, setTriggerFilter] = useState(true); 
    const [allObj, setAllObj] = useState({label: 'All', id: 'All'}); 
    const [productFilter1, setProductFilter1] = useState(allObj); 
    const [productFilter2, setProductFilter2] = useState(allObj); 
    const [productFilterList, setProductFilterList] = useState([allObj]); 
    const [feeCategoryFilter1, setFeeCategoryFilter1] = useState(allObj); 
    const [feeCategoryFilter2, setFeeCategoryFilter2] = useState(allObj); 
    const [feeCategoryFilterList, setFeeCategoryFilterList] = useState([allObj]); 
    const [billingRateFilter1, setBillingRateFilter1] = useState(allObj); 
    const [billingRateFilter2, setBillingRateFilter2] = useState(allObj); 
    const [billingRateFilterList, setBillingRateFilterList] = useState([allObj]); 
    const [rebateSetupTypeFilter1, setRebateSetupTypeFilter1] = useState(allObj); 
    const [rebateSetupTypeFilter2, setRebateSetupTypeFilter2] = useState(allObj); 
    const [rebateSetupTypeFilterList, setRebateSetupTypeFilterList] = useState([allObj]); 
    // state for input configs 
    const [rebateSetupInputConfig, setRebateSetupInputConfig] = useState([]); 
    const [groupSetupInputConfig, setGroupSetupInputConfig] = useState([]); 
    const [rebateSetupInputLists, setRebateSetupInputLists] = useState({
        active: [{label: '--select--', id: '--select--'}, {label: 'Active', id: "true"}, {label: 'Inactive', id: "false"}], 
        rebatesetuptypeid: [{label: '--select--', id: '--select--'}], 
        producttypeid: [{label: '--select--', id: '--select--'}], 
        feecategoryid: [{label: '--select--', id: '--select--'}], 
        billingrateid: [{label: '--select--', id: '--select--'}], 
        groupid: [{label: '--select--', id: '--select--'}] 
    }); 
    const [groupInputConfig, setGroupInputConfig] = useState([]); 
    const [groupInputLists, setGroupInputLists] = useState({
        active: [{label: '--select--', id: '--select--'}, {label: 'Active', id: "true"}, {label: 'Inactive', id: "false"}], 
        payoutmethodid: [{label: '--select--', id: '--select--'}],
        achaccounttype: [{label: '--select--', id: '--select--'}]
    }); 
    // initialize state for rebate components
    const [rebateComponentConfig, setRebateComponentConfig] = useState([]); 
    const [groupRebateComponentConfig, setGroupRebateComponentConfig] = useState([]); 
    const [consortiumRebateComponents, setConsortiumRebateComponents] = useState({}); 
    const [groupRebateComponents, setGroupRebateComponents] = useState({}); 
    const [editConsortiumComponents, setEditConsortiumComponents] = useState(false); 
    const [editGroupComponents, setEditGroupComponents] = useState(false); 
    const [showGroupComponents, setShowGroupComponents] = useState(false); 
    const [groupId, setGroupId] = useState(null); 
    // initialize refs for initialRender
    const initialRender1 = useRef(true); 
    const initialRender2 = useRef(true); 

    // event handler for rebate setup row component
    const onRebateSetupEdit = (row) => {
        // assign row 
        setEditConsortiumRebateSetupRow(editConsortiumRebateSetupRow => editConsortiumRebateSetupRow = row); 
        // show modal 
        setEditConsortiumRebateSetupModal(editConsortiumRebateSetupModal => editConsortiumRebateSetupModal = true); 
    }

    // event handler for group edit
    const onGroupEdit = (row) => {
        // assign row 
        setEditConsortiumGroupRow(editConsortiumGroupRow => editConsortiumGroupRow = row); 
        // show modal
        setEditConsortiumGroupModal(editConsortiumGroupModal => editConsortiumGroupModal = true); 
    }

    // event handler for group setup edit
    const onGroupSetupEdit = (row) => {
        // assign row 
        setEditGroupRebateSetupRow(editGroupRebateSetupRow => editGroupRebateSetupRow = row); 
        // show modal 
        setEditGroupRebateSetupModal(editGroupRebateSetupModal => editGroupRebateSetupModal = row); 
    }

    // event handler for edit consortium rebate components
    const onEditConsortiumRebateComponents = () => {
        setEditConsortiumComponents(editConsortiumComponents => editConsortiumComponents = true); 
    }

    // event handler for edit group rebate components
    const onEditGroupRebateComponents = () => {
        setEditGroupComponents(editGroupComponents => editGroupComponents = true); 
    }

    // function wrapper to pass row component to datatable
    const ConsortiumRowComponent = (row, count, tableHeader) =>{
        return <ConsortiumViewRow row={row} count={count} tableHeader={tableHeader} back={'/ConsortiumManagementPage'} enableEdit={editButtonBool} />
    } 

    // function wrapper to pass row component to datatable 
    const RebateSetupRowComponent = (row, count, tableHeader)=> {
        return <StandardRowFormatted row={row} count={count} tableHeader={tableHeader} onEditClick={onRebateSetupEdit} enableEdit={editButtonBool} rateTypeId={rebateInputTypeId} />
    }

    // function wrapper to pass row component to datatable 
    const GroupRowComponent = (row, count, tableHeader) => {
        return <StandardRowFormatted row={row} count={count} tableHeader={tableHeader} onEditClick={onGroupEdit} enableEdit={editButtonBool} />
    }

    // function wrapper to pass row component to datatable 
    const GroupSetupRowComponent = (row, count, tableHeader) => {
        return <StandardRowFormatted row={row} count={count} tableHeader={tableHeader} onEditClick={onGroupSetupEdit} enableEdit={editButtonBool} rateTypeId={rebateInputTypeId} />
    }

    // function to set snackbar state
    const snackbarAlert = (show, message, color) => {
        setSnackbarMessage(snackbarMessage => snackbarMessage = message);
        setSnackbarColor(snackbarColor => snackbarColor = color);
        setShowSnackbar(showSnackbar => showSnackbar = show);
    }

    // event handler for edit click 
    const onEditClick = () => {
        // show modal 
        setEditConsortiumModal(editConsortiumModal => editConsortiumModal = true); 
    }

    // event handler for add click
    const onAddClick = () => {
        // show modal 
        setAddConsortiumMasterCompanyModal(addConsortiumMasterCompanyModal => addConsortiumMasterCompanyModal = true); 
    }

    // event handler for add rebate setup click 
    const onAddRebateSetupClick = () => {
        // show modal
        setAddConsortiumRebateSetupModal(addConsortiumRebateSetupModal => addConsortiumRebateSetupModal = true); 
    }

    // event handler for add group click 
    const onAddGroupClick = () => {
        setAddConsortiumGroupModal(addConsortiumGroupModal => addConsortiumGroupModal = true); 
    }

    // event handler for add group setup click 
    const onAddGroupSetupClick = () => {
        setAddGroupRebateSetupModal(addGroupRebateSetupModal => addGroupRebateSetupModal = true); 
    }

    // make http request to fetch page data 
    const getConsortiumData = () => {
        return new Promise((resolve, reject) => {
            setShowSpinner(showSpinner => showSpinner = true); 
            GET('/consortium/consortiumManagementPage', {
                consortiumid: consortiumId
            }).then(res => {
                // set member table state
                setConsortiumDataList(consortiumDataList => consortiumDataList = res['data']['ConsortiumManagementData']); 
                setConsortiumTableHeader(consortiumTableHeader => consortiumTableHeader = res['data']['ConsortiumManagementTableHeader']); 
                // set rebate setups table state
                setRebateSetupDataList(rebateSetupDataList => rebateSetupDataList = res['data']['ConsortiumRebateSetupData']); 
                setShowRebateSetupDataList(showRebateSetupDataList => showRebateSetupDataList = res['data']['ConsortiumRebateSetupData']); 
                setRebateSetupTableHeader(rebateSetupTableHeader => rebateSetupTableHeader = res['data']['ConsortiumRebateSetupCols']); 
                // set group table state
                setGroupDataList(groupDataList => groupDataList = res['data']['ConsortiumGroupData']); 
                setGroupTableHeader(groupTableHeader => groupTableHeader = res['data']['ConsortiumGroupCols']); 
                setGroupDataListLength(groupDataListLength => groupDataListLength = res['data']['ConsortiumGroupData'].length); 
                setGroupRebateSetupDataList(groupRebateSetupDataList => groupRebateSetupDataList = res['data']['GroupRebateSetupData']); 
                setShowGroupRebateSetupDataList(showGroupRebateSetupDataList => showGroupRebateSetupDataList = res['data']['GroupRebateSetupData']); 
                setGroupRebateSetupTableHeader(groupRebateSetupTableHeader => groupRebateSetupTableHeader = res['data']['GroupRebateSetupCols']); 
                // set edit entitlement state 
                let temp = false; 
                if (res['data']['ConsortiumEntitlement'] === true
                    && process.env.REACT_APP_CONSORTIUM_MANAGEMENT === '1') {
                    temp = true; 
                }
                setEditButtonBool(editButtonBool => editButtonBool = temp); 
                // set portfolio state
                if (res['data']['ConsortiumPortfolio']) {
                    setPortfolio(portfolio => portfolio = res['data']['ConsortiumPortfolio']['label']); 
                }
                setPortfolioObj(portfolioObj => portfolioObj = res['data']['ConsortiumPortfolio']); 
                setPortfolioList(portfolioList => portfolioList = res['data']['PortfolioList']); 
                // set consortium payout type state
                if (res['data']['ConsortiumPayoutType']) {
                    setConsortiumPayoutType(consortiumPayoutType => consortiumPayoutType = res['data']['ConsortiumPayoutType']['label']); 
                }
                setConsortiumPayoutTypeObj(consortiumPayoutTypeObj => consortiumPayoutTypeObj = res['data']['ConsortiumPayoutType']); 
                setConsortiumPayoutTypeList(consortiumPayoutTypeList => consortiumPayoutTypeList = res['data']['ConsortiumPayoutTypeList']); 
                // get rebate input type id 
                setRebateInputTypeId(rebateInputTypeId => rebateInputTypeId = res['data']['RebateInputTypeId']); 
                // set master company list 
                setMasterCompanyList(masterCompanyList => masterCompanyList = res['data']['MasterCompanyList']); 
                // set state for rebate setup filters (add allObj selection to all lists)
                setRebateSetupTypeFilterList(rebateSetupTypeFilterList => rebateSetupTypeFilterList = [allObj, ...res['data']['RebateSetupTypeList']]); 
                setProductFilterList(productFilterList => productFilterList = [allObj, ...res['data']['ProductTypeList']]); 
                setFeeCategoryFilterList(feeCategoryFilterList => feeCategoryFilterList = [allObj, ...res['data']['FeeCategoryList']]); 
                setBillingRateFilterList(billingRateFilterList => billingRateFilterList = [allObj, ...res['data']['BillingRateList']]); 
                // set state for input configs
                setRebateSetupInputConfig(rebateSetupInputConfig => rebateSetupInputConfig = res['data']['ConsortiumRebateSetupConfig']); 
                setGroupSetupInputConfig(groupSetupInputConfig => groupSetupInputConfig = res['data']['GroupRebateSetupConfig']); 
                setGroupInputConfig(groupInputConfig => groupInputConfig = res['data']['ConsortiumGroupConfig']); 
                setRebateSetupInputLists(rebateSetupInputLists => rebateSetupInputLists = {
                    active: [{label: 'Active', id: true}, {label: 'Inactive', id: false}], 
                    rebatesetuptypeid: res['data']['RebateSetupTypeList'], 
                    producttypeid: res['data']['ProductTypeList'], 
                    feecategoryid: res['data']['FeeCategoryList'], 
                    billingrateid: res['data']['BillingRateList'], 
                    groupid: res['data']['GroupList'] 
                }); 
                setGroupInputLists(groupInputLists => groupInputLists = {
                    active: [{label: 'Active', id: true}, {label: 'Inactive', id: false}], 
                    payoutmethodid: res['data']['PayoutMethodList'],
                    achaccounttype: res['data']['AchAccountTypeList']
                }); 
                // set state for rebate components 
                setRebateComponentConfig(rebateComponentConfig => rebateComponentConfig = [...res['data']['RebateComponentConfig']]); 
                setGroupRebateComponentConfig(groupRebateComponentConfig => groupRebateComponentConfig = [...res['data']['RebateComponentConfig']]); 
                setConsortiumRebateComponents(consortiumRebateComponents => consortiumRebateComponents = res['data']['ConsortiumRebateComponents']); 
                setGroupRebateComponents(groupRebateComponents => groupRebateComponents = res['data']['GroupRebateComponents']); 
                if (res['data']['ConsortiumGroupData'].length > 0) {
                    setShowGroupComponents(showGroupComponents => showGroupComponents = true); 
                    setGroupId(groupId => groupId = res['data']['ConsortiumGroupData'][0]['groupid']); 
                }
                else {
                    setShowGroupComponents(showGroupComponents => showGroupComponents = false); 
                    setGroupId(groupId => groupId = null); 
                }
                // trigger page filter
                setTriggerFilter(triggerFilter => triggerFilter = !triggerFilter); 
                // hide spinner
                setShowSpinner(showSpinner => showSpinner = false); 
                setIsMenuLoaded(true);
                // resolve on success
                resolve(res); 
            }).catch(err => {
                // hide spinner
                setShowSpinner(showSpinner => showSpinner = false); 
                setIsMenuLoaded(false);
                // reject on error 
                reject(err); 
            }); 
        }); 
    }

    // make http request to fetch page data (refresh does not include input configs )
    const getRefreshData = () => {
        return new Promise((resolve, reject) => {
            setShowSpinner(showSpinner => showSpinner = true); 
            GET('/consortium/consortiumManagementPage', {
                consortiumid: consortiumId
            }).then(res => {
                // set member table state
                setConsortiumDataList(consortiumDataList => consortiumDataList = res['data']['ConsortiumManagementData']); 
                setConsortiumTableHeader(consortiumTableHeader => consortiumTableHeader = res['data']['ConsortiumManagementTableHeader']); 
                // set rebate setups table state
                setRebateSetupDataList(rebateSetupDataList => rebateSetupDataList = res['data']['ConsortiumRebateSetupData']); 
                setShowRebateSetupDataList(showRebateSetupDataList => showRebateSetupDataList = res['data']['ConsortiumRebateSetupData']); 
                setRebateSetupTableHeader(rebateSetupTableHeader => rebateSetupTableHeader = res['data']['ConsortiumRebateSetupCols']); 
                // set group table state
                setGroupDataList(groupDataList => groupDataList = res['data']['ConsortiumGroupData']); 
                setGroupTableHeader(groupTableHeader => groupTableHeader = res['data']['ConsortiumGroupCols']); 
                setGroupDataListLength(groupDataListLength => groupDataListLength = res['data']['ConsortiumGroupData'].length); 
                setGroupRebateSetupDataList(groupRebateSetupDataList => groupRebateSetupDataList = res['data']['GroupRebateSetupData']); 
                setShowGroupRebateSetupDataList(showGroupRebateSetupDataList => showGroupRebateSetupDataList = res['data']['GroupRebateSetupData']); 
                setGroupRebateSetupTableHeader(groupRebateSetupTableHeader => groupRebateSetupTableHeader = res['data']['GroupRebateSetupCols']); 
                // set edit entitlement state 
                let temp = false; 
                if (res['data']['ConsortiumEntitlement'] === true
                    && process.env.REACT_APP_CONSORTIUM_MANAGEMENT === '1') {
                    temp = true; 
                }
                setEditButtonBool(editButtonBool => editButtonBool = temp); 
                // set portfolio state
                if (res['data']['ConsortiumPortfolio']) {
                    setPortfolio(portfolio => portfolio = res['data']['ConsortiumPortfolio']['label']); 
                }
                setPortfolioObj(portfolioObj => portfolioObj = res['data']['ConsortiumPortfolio']); 
                setPortfolioList(portfolioList => portfolioList = res['data']['PortfolioList']); 
                // set consortium payout type state
                if (res['data']['ConsortiumPayoutType']) {
                    setConsortiumPayoutType(consortiumPayoutType => consortiumPayoutType = res['data']['ConsortiumPayoutType']['label']); 
                }
                setConsortiumPayoutTypeObj(consortiumPayoutTypeObj => consortiumPayoutTypeObj = res['data']['ConsortiumPayoutType']); 
                setConsortiumPayoutTypeList(consortiumPayoutTypeList => consortiumPayoutTypeList = res['data']['ConsortiumPayoutTypeList']); 
                // get rebate input type id 
                setRebateInputTypeId(rebateInputTypeId => rebateInputTypeId = res['data']['RebateInputTypeId']); 
                // set master company list 
                setMasterCompanyList(masterCompanyList => masterCompanyList = res['data']['MasterCompanyList']); 
                // set state for rebate setup filters (add allObj selection to all lists)
                setRebateSetupTypeFilterList(rebateSetupTypeFilterList => rebateSetupTypeFilterList = [allObj, ...res['data']['RebateSetupTypeList']]); 
                setProductFilterList(productFilterList => productFilterList = [allObj, ...res['data']['ProductTypeList']]); 
                setFeeCategoryFilterList(feeCategoryFilterList => feeCategoryFilterList = [allObj, ...res['data']['FeeCategoryList']]); 
                setBillingRateFilterList(billingRateFilterList => billingRateFilterList = [allObj, ...res['data']['BillingRateList']]); 
                // set state for rebate components 
                setRebateComponentConfig(rebateComponentConfig => rebateComponentConfig = [...res['data']['RebateComponentConfig']]); 
                setGroupRebateComponentConfig(groupRebateComponentConfig => groupRebateComponentConfig = [...res['data']['RebateComponentConfig']]); 
                setConsortiumRebateComponents(consortiumRebateComponents => consortiumRebateComponents = res['data']['ConsortiumRebateComponents']); 
                setGroupRebateComponents(groupRebateComponents => groupRebateComponents = res['data']['GroupRebateComponents']); 
                if (res['data']['ConsortiumGroupData'].length > 0) {
                    setShowGroupComponents(showGroupComponents => showGroupComponents = true); 
                    setGroupId(groupId => groupId = res['data']['ConsortiumGroupData'][0]['groupid']); 
                }
                else {
                    setShowGroupComponents(showGroupComponents => showGroupComponents = false); 
                    setGroupId(groupId => groupId = null); 
                }
                // trigger page filter
                setTriggerFilter(triggerFilter => triggerFilter = !triggerFilter); 
                // hide spinner
                setShowSpinner(showSpinner => showSpinner = false); 
                // resolve on success
                resolve(res); 
            }).catch(err => {
                // hide spinner
                setShowSpinner(showSpinner => showSpinner = false); 
                // reject on error 
                reject(err); 
            }); 
        }); 
    }

    // useEffect to run on initial render
    useEffect(() => {
        // get data for page 
        getConsortiumData().then(res => {
            console.log(res); 
        }).catch(err => {
            console.log(err); 
        }); 
    }, []); 

    // useEffect to filter rebate setup table 
    useEffect(() => {
        // do not run on initial render
        if (!initialRender1.current){
            // set status var from dropdown 
            // declare list of functions with parameters to filter/search list
            const functionList = [
                {function: statusFilter, value: showInactiveRebateSetups, flag: 1, cols: ['active']}, 
                {function: standardFilter, value:  rebateSetupTypeFilter1['label'], flag: 1, cols: ['rebatesetuptypedescription']}, 
                {function: standardFilter, value: productFilter1['label'], flag: 1, cols: ['producttypedescription']}, 
                {function: standardFilter, value: feeCategoryFilter1['label'], flag: 1, cols: ['feecategorydescription']}, 
                {function: standardFilter, value: billingRateFilter1['label'], flag: 1, cols: ['billingratedescription']},
            ];
            // use applyFilters function to search by running all functions declared above
            let filteredList = applyFilters(rebateSetupDataList, functionList);
            // update showDataList
            setShowRebateSetupDataList(showRebateSetupDataList => showRebateSetupDataList = filteredList);
        }
        else{
            initialRender1.current = false;
        }
    }, [showInactiveRebateSetups, rebateSetupTypeFilter1, productFilter1, feeCategoryFilter1, billingRateFilter1, triggerFilter]); 

    // useEffect to filter group setup table 
    useEffect(() => {
        // do not run on initial render
        if (!initialRender2.current){
            // set status var from dropdown 
            // declare list of functions with parameters to filter/search list
            const functionList = [
                {function: statusFilter, value: showInactiveGroupSetups, flag: 1, cols: ['active']}, 
                {function: standardFilter, value:  rebateSetupTypeFilter2['label'], flag: 1, cols: ['rebatesetuptypedescription']}, 
                {function: standardFilter, value: productFilter2['label'], flag: 1, cols: ['producttypedescription']}, 
                {function: standardFilter, value: feeCategoryFilter2['label'], flag: 1, cols: ['feecategorydescription']}, 
                {function: standardFilter, value: billingRateFilter2['label'], flag: 1, cols: ['billingratedescription']},
            ];
            // use applyFilters function to search by running all functions declared above
            let filteredList = applyFilters(groupRebateSetupDataList, functionList);
            // update showDataList
            setShowGroupRebateSetupDataList(showGroupRebateSetupDataList => showGroupRebateSetupDataList = filteredList);
        }
        else{
            initialRender2.current = false;
        }
    }, [showInactiveGroupSetups, rebateSetupTypeFilter2, productFilter2, feeCategoryFilter2, billingRateFilter2, triggerFilter]); 

    // context to pass to children
    const settings = {
        viewModal, 
        setViewModal, 
        viewCompany,  
        setViewCompany, 
        editConsortiumModal, 
        setEditConsortiumModal, 
        portfolio, 
        setPortfolio, 
        portfolioList, 
        portfolioObj, 
        setPortfolioObj,
        addConsortiumMasterCompanyModal, 
        setAddConsortiumMasterCompanyModal, 
        masterCompanyList, 
        snackbarAlert,
        showSnackbar, 
        setShowSnackbar,
        snackbarMessage, 
        snackbarColor,
        editModal, 
        setEditModal,
        editCompany, 
        setEditCompany, 
        getConsortiumData, 
        addConsortiumRebateSetupModal, 
        setAddConsortiumRebateSetupModal, 
        editConsortiumRebateSetupModal, 
        setEditConsortiumRebateSetupModal, 
        editConsortiumRebateSetupRow, 
        setEditConsortiumRebateSetupRow, 
        rebateSetupInputConfig, 
        rebateSetupInputLists, 
        rebateInputTypeId, 
        getRefreshData, 
        groupSetupInputConfig, 
        setGroupSetupInputConfig, 
        addGroupRebateSetupModal, 
        setAddGroupRebateSetupModal,
        editGroupRebateSetupModal, 
        setEditGroupRebateSetupModal,
        editGroupRebateSetupRow, 
        setEditGroupRebateSetupRow, 
        addConsortiumGroupModal, 
        setAddConsortiumGroupModal,
        groupInputConfig, 
        setGroupInputConfig,
        groupInputLists, 
        setGroupInputLists, 
        editConsortiumGroupModal, 
        setEditConsortiumGroupModal,
        editConsortiumGroupRow, 
        setEditConsortiumGroupRow,
        consortiumPayoutType, 
        setConsortiumPayoutType, 
        consortiumPayoutTypeObj, 
        setConsortiumPayoutTypeObj, 
        consortiumPayoutTypeList 
    }

    //reset functionality 
    const resetToDefaultRebateTab = () => {
        setRebateSetupTypeFilter1(allObj);
        setProductFilter1(allObj);
        setFeeCategoryFilter1(allObj);
        setBillingRateFilter1(allObj);
    }

    const enableResetAllRebateTab = () => {
        if(rebateSetupTypeFilter1.label !== 'All' || productFilter1.label !== 'All'
            || feeCategoryFilter1.label !== 'All' || billingRateFilter1.label !== 'All'
        ){
            return true;
        }
        return false;
    }

    useEffect(() => {
        if(isMenuLoaded && enableResetAllRebateTab()){
            setEnableResetRebateTab(true);
        } else {
            setEnableResetRebateTab(false);
        }
    }, [rebateSetupTypeFilter1, productFilter1, feeCategoryFilter1, billingRateFilter1, isMenuLoaded])

    //reset functionality 
    const resetToDefaultGroupSetupTab = () => {
        setRebateSetupTypeFilter2(allObj);
        setProductFilter2(allObj);
        setFeeCategoryFilter2(allObj);
        setBillingRateFilter2(allObj);
    }

    const enableResetAllGroupSetupTab = () => {
        if(rebateSetupTypeFilter2.label !== 'All' || productFilter2.label !== 'All'
            || feeCategoryFilter2.label !== 'All' || billingRateFilter2.label !== 'All'
        ){
            return true;
        }
        return false;
    }

    useEffect(() => {
        if(isMenuLoaded && enableResetAllGroupSetupTab()){
            setEnableResetGroupSetupTab(true);
        } else {
            setEnableResetGroupSetupTab(false);
        }
    }, [rebateSetupTypeFilter2, productFilter2, feeCategoryFilter2, billingRateFilter2, isMenuLoaded])

    return(
        <div class='summary-page'>
            {/* wrap children so they have access to variables in PageContext */}
            <PageContext.Provider value={ settings }>
                {/* header and navslider present on every page */}
                <HeaderBanner indicator={1}/>
                {/* breadcrumbs */}
                <div className="pt-1 ms-3">
                    <PageBreadcrumbs />
                </div>
                {/* modal for viewing sub companies. Default is hidden state */}
                <ViewSubCompaniesModal />
                <EditConsortiumModal />
                <AddConsortiumMasterCompany />
                <RemoveConsortiumMasterCompany />
                <AddConsortiumRebateSetup />
                <EditConsortiumRebateSetup />
                <AddGroupRebateSetup />
                <EditGroupRebateSetup />
                <AddConsortiumGroupModal />
                <EditConsortiumGroupModal />
                <RebateComponentsEditModal show={editConsortiumComponents} setShow={setEditConsortiumComponents} valuesArg={consortiumRebateComponents} configArg={rebateComponentConfig} path='/consortium/rebateComponents' consortiumId={consortiumId} getRefreshData={getRefreshData} />
                <RebateComponentsEditModal show={editGroupComponents} setShow={setEditGroupComponents} valuesArg={groupRebateComponents} configArg={groupRebateComponentConfig} path='/consortium/rebateComponents' consortiumId={consortiumId} groupId={groupId} getRefreshData={getRefreshData} />
                {/* snackbar component for alerts */}
                <SnackbarAlert />
                <div className="container-fluid d-flex flex-column">
                    <div className="d-flex flex-column flex-grow-1 p-2">
                        {/* page label */}
                        <div className="mb-2" style={{ borderRadius: "12px", background: "white" }}>
                            <div className="d-flex p-3 align-items-center justify-content-between">
                                <div className="d-flex">
                                    <div className="pe-3">
                                        <InfoLabel title={'Consortium ID: '} content={consortiumId} />
                                    </div>
                                    <div class="vr me-3"></div>
                                    <div className="pe-3">
                                        <InfoLabel title={'Consortium Type: '} content={portfolio} />
                                    </div>
                                    <div class="vr me-3"></div>
                                    <div className="pe-3">
                                        <InfoLabel title={'Payout Type: '} content={consortiumPayoutType} />
                                    </div>
                                </div>
                                <div>
                                    {editButtonBool && <ButtonComponent tag='Edit' onButtonClick={onEditClick} border={'#3D3D3D 1px solid'} background={'#fff'} color={'#001317'} />}
                                </div>
                            </div>
                        </div>
                        {/* tabs component for navigation between sections without leaving page */}
                        <div>
                            <PageTabs value={tabValue} setValue={setTabValue} tabList={tabList} />
                        </div>
                        {/* render tabs */}
                        {tabValue == 0 ?
                            <div className='bg-white p-3 pt-2' style={{ borderRadius: "0px 0px 12px 12px" }}>
                                <div className='d-flex align-items-center justify-content-end'>

                                    <div>
                                        {editButtonBool && <ButtonComponent tag={'Add ' + process.env.REACT_APP_MASTER_COMPANY_ID_TAG} onButtonClick={onAddClick} border={'#3D3D3D 1px solid'} background={'#3D3D3D'} color={'#FFFFFF'} width='max-content' />}
                                    </div>
                                </div>
                                <hr className='m-0 mb-2 mt-2' />

                                <OrderedDataTable RowComponent={ConsortiumRowComponent} tableHeader={consortiumTableHeader} dataList={consortiumDataList} showSpinner={showSpinner} numToPage={25} skeletonHeight='28vh' />
                            </div>
                            : tabValue == 1 ?
                                <div className='d-flex flex-column gap-2 bg-white p-3 pt-2' style={{ borderRadius: "0px 0px 12px 12px" }}>
                                    <div className='d-flex align-items-center justify-content-between'>
                                        <div className='d-flex gap-3 align-items-center'>
                                            <PageDropdownBasic alignContent='left' tag='Rebate setups' list={setupTypeList}  value={showInactiveRebateSetups} setValue={setShowInactiveRebateSetups} width={'7rem'} />
                                            <div className= "pe-3 align-self-center text-decoration-underline" style={{color: `${showInactiveRebateSetups===defaultCheckboxDropdownState ? '#BDBDBD': '#0295BE'}`, cursor: 'pointer', fontFamily: 'Roboto medium'}} onClick={() => showInactiveRebateSetups===defaultCheckboxDropdownState ? null:setShowInactiveRebateSetups(defaultCheckboxDropdownState)}>
                                                Reset All
                                            </div>
                                        </div>
                                        {editButtonBool && <ButtonComponent tag='Add Rebate Setup' onButtonClick={onAddRebateSetupClick} border={'#3D3D3D 1px solid'} background={'#3D3D3D'} color={'#FFFFFF'} width='max-content' />}
                                        {/* <EntitledButton entitledBool={editButtonBool} tag='Add Rebate Setup' cssClass='table-add-button' onClick={()=>setAddRebateSetupModal(addRebateSetupModal => addRebateSetupModal = true)} />  */}
                                    </div>
                                    <hr className='m-0' />
                                    <div>
                                        <div className='d-flex gap-3 align-items-center justify-content-start' style={{ flexWrap: 'wrap' }}>
                                            {/* <div item xs={4} >
                                        <label class='rebate-filter-label'><b>Rebate Setup Filters: </b></label>
                                    </div> */}
                                            <div item xs={4} >
                                                <PageDropdown font={'14px'} width={"9em"} tag='Rebate Setup Type: ' obj={rebateSetupTypeFilter1} setObj={setRebateSetupTypeFilter1} list={rebateSetupTypeFilterList} />
                                            </div>
                                            <div item xs={4} >
                                                <PageDropdown font={'14px'} width={"7em"} tag='Product Type: ' obj={productFilter1} setObj={setProductFilter1} list={productFilterList} />
                                            </div>
                                            <div item xs={4} >
                                                <PageDropdown font={'14px'} width={"9em"} tag='Fee Category: ' obj={feeCategoryFilter1} setObj={setFeeCategoryFilter1} list={feeCategoryFilterList} />
                                            </div>
                                            <div item xs={4} >
                                                <PageDropdown font={'14px'} width={"8em"} tag='Billing Rate: ' obj={billingRateFilter1} setObj={setBillingRateFilter1} list={billingRateFilterList} />
                                            </div>
                                            <div className= "pe-3 align-self-center text-decoration-underline" style={{color: `${enableResetRebateTab ? '#0295BE': '#BDBDBD'}`, cursor: 'pointer', fontFamily: 'Roboto medium'}} onClick={() => enableResetRebateTab ? resetToDefaultRebateTab(): null}>
                                                    Reset All
                                            </div>
                                        </div>
                                    </div>
                                    <hr className='m-0' />
                                    <div>
                                        <RebateComponentDisplay tag='Consortium Rebate Components:' values={consortiumRebateComponents} setValues={setConsortiumRebateComponents} config={rebateComponentConfig} portfolioId={portfolioObj} showOverride={!showSpinner} entitledBool={editButtonBool} onClick={onEditConsortiumRebateComponents} />
                                        <div className='mt-2'>
                                            <TableName>Rebate Setup</TableName>
                                            <OrderedDataTable varHeight={'450px'} RowComponent={RebateSetupRowComponent} tableHeader={rebateSetupTableHeader} dataList={showRebateSetupDataList} showSpinner={showSpinner} numToPage={25} skeletonHeight='28vh' sortingEnabled={true} stickyFirstColumnEnabled={true} />
                                        </div>
                                    </div>
                                </div>
                                : tabValue == 2 ?
                                    <div className='bg-white p-3 pt-2' style={{ borderRadius: "0px 0px 12px 12px" }}>
                                        <div className='d-flex align-items-center justify-content-end'>

                                            <div>
                                                {editButtonBool && groupDataListLength == 0 && <ButtonComponent tag={'Add Group'} onButtonClick={onAddGroupClick} border={'#3D3D3D 1px solid'} background={'#3D3D3D'} color={'#FFFFFF'} width='max-content' />}
                                            </div>
                                        </div>
                                        {editButtonBool && groupDataListLength == 0 && <hr className='m-0 mb-2 mt-2' />}
                                        <OrderedDataTable RowComponent={GroupRowComponent} tableHeader={groupTableHeader} dataList={groupDataList} showSpinner={showSpinner} numToPage={25} skeletonHeight='28vh' />
                                    </div>
                                    : tabValue == 3 ?
                                        <div className='d-flex flex-column gap-2 bg-white p-3 pt-2' style={{ borderRadius: "0px 0px 12px 12px" }}>
                                            <div className='d-flex align-items-center justify-content-between'>
                                                <div className='d-flex gap-3 align-items-center'>
                                                    <PageDropdownBasic alignContent='left' tag='Group setups' list={setupTypeList}  value={showInactiveGroupSetups} setValue={setShowInactiveGroupSetups} width={'7rem'} />
                                                    <div className= "pe-3 align-self-center text-decoration-underline" style={{color: `${showInactiveGroupSetups===defaultCheckboxDropdownState ? '#BDBDBD': '#0295BE'}`, cursor: 'pointer', fontFamily: 'Roboto medium'}} onClick={() => showInactiveGroupSetups===defaultCheckboxDropdownState ? null:setShowInactiveGroupSetups(defaultCheckboxDropdownState)}>
                                                        Reset All
                                                    </div>
                                                </div>
                                                {editButtonBool && <ButtonComponent tag='Add Group Setup' onButtonClick={onAddGroupSetupClick} border={'#3D3D3D 1px solid'} background={'#3D3D3D'} color={'#FFFFFF'} width='max-content' />}
                                                {/* <EntitledButton entitledBool={editButtonBool} tag='Add Rebate Setup' cssClass='table-add-button' onClick={()=>setAddRebateSetupModal(addRebateSetupModal => addRebateSetupModal = true)} />  */}
                                            </div>
                                            <hr className='m-0' />
                                            <div>
                                                <div className='d-flex gap-3 align-items-center justify-content-start' style={{ flexWrap: 'wrap' }}>
                                                    {/* <div item xs={4} >
                                        <label class='rebate-filter-label'><b>Rebate Setup Filters: </b></label>
                                    </div> */}
                                                    <div item xs={4} >
                                                        <PageDropdown font={'14px'} width={"9em"} tag='Rebate Setup Type: ' obj={rebateSetupTypeFilter2} setObj={setRebateSetupTypeFilter2} list={rebateSetupTypeFilterList} />
                                                    </div>
                                                    <div item xs={4} >
                                                        <PageDropdown font={'14px'} width={"7em"} tag='Product Type: ' obj={productFilter2} setObj={setProductFilter2} list={productFilterList} />
                                                    </div>
                                                    <div item xs={4} >
                                                        <PageDropdown font={'14px'} width={"9em"} tag='Fee Category: ' obj={feeCategoryFilter2} setObj={setFeeCategoryFilter2} list={feeCategoryFilterList} />
                                                    </div>
                                                    <div item xs={4} >
                                                        <PageDropdown font={'14px'} width={"8em"} tag='Billing Rate: ' obj={billingRateFilter2} setObj={setBillingRateFilter2} list={billingRateFilterList} />
                                                    </div>
                                                    <div className= "pe-3 align-self-center text-decoration-underline" style={{color: `${enableResetGroupSetupTab ? '#0295BE': '#BDBDBD'}`, cursor: 'pointer', fontFamily: 'Roboto medium'}} onClick={() => enableResetGroupSetupTab ? resetToDefaultGroupSetupTab(): null}>
                                                        Reset All
                                                    </div>
                                                </div>
                                            </div>
                                            <hr className='m-0' />
                                            <div>
                                                <RebateComponentDisplay tag='Group Rebate Components:' values={groupRebateComponents} setValues={setGroupRebateComponents} config={groupRebateComponentConfig} portfolioId={portfolioObj} showOverride={!showSpinner} entitledBool={editButtonBool || showGroupComponents} onClick={onEditGroupRebateComponents} />
                                                <div className='mt-2'>
                                                    <TableName>Group Setup</TableName>
                                                    <OrderedDataTable varHeight={'450px'} RowComponent={GroupSetupRowComponent} tableHeader={groupRebateSetupTableHeader} dataList={showGroupRebateSetupDataList} showSpinner={showSpinner} numToPage={25} skeletonHeight='28vh' sortingEnabled={true} stickyFirstColumnEnabled={true} />
                                                </div>
                                            </div>
                                        </div>
                                        : <></>}
                    </div>
                </div>
                
                <Footer cssClassName="footer-main-comp"/>
            </PageContext.Provider>
        </div>
    ); 
}

export default ConsortiumManagementPage; 